import Modal from "components/Modals/Modal";
import React, { useMemo } from "react";
import {
  EnvelopeIcon,
  ExclamationTriangleIcon,
} from "@heroicons/react/24/solid";
import { LogViewer } from "components/LogViewer";

export interface FailedStartModalProps {
  logFileContent: string;
  show: boolean;
  setShow: (show: boolean) => void;
  onCancel?: () => void;
  onSuccess?: () => void;
}

export const FailedStartModal: React.FC<FailedStartModalProps> = ({
  logFileContent,
  show,
  setShow,
  onCancel = () => {},
  onSuccess = () => {},
}) => {
  return (
    <Modal
      isOpen={show}
      setOpen={setShow}
      onClose={() => {
        setShow(false);
      }}
      title={"Previous Start Attempt Failed"}
      body={
        <>
          <div className="w-[450px] ">
            <div className="flex flex-col">
              <div className="flex flex-row justify-between">
                <div className="flex flex-row items-center mt-2 text-rose-500">
                  <ExclamationTriangleIcon className="h-5 w-5" />
                  <p className="text-sm ml-2">View Error Logs</p>
                </div>
                <div className="flex flex-row items-center mt-2 text-white">
                  <p className="text-sm ml-2">
                    Contact: brev-support@nvidia.com
                  </p>
                </div>
              </div>
              <LogViewer logs={logFileContent} title="Error Logs" />
            </div>
          </div>
        </>
      }
      confirmLabel={"Close"}
      onSuccess={() => onSuccess()}
    />
  );
};
